module.exports = __webpack_public_path__ + "static/media/doorSvg.57f54bc2.svg";